<div *ngIf="scenes && scenes.length > 0" >
  <mat-form-field class="select-container">
    <mat-select placeholder="Select Scene" style="margin: 4px" [formControl]="control">
      <mat-option value="next" *ngIf="showNext">Link To Next Scene</mat-option>
      <ng-container *ngFor="let scene of scenes;">
        <mat-option [value]="scene.id">{{scene.section.title + "/ "+ scene.title}}</mat-option>
      </ng-container>
    </mat-select>
  </mat-form-field>
  
</div>
